import React, {Fragment, useCallback, useState} from 'react';

import {MyProfileEnum} from 'main/analytics/gaTagsEnum';
import {DataCard, PlanTypeChip} from 'presentation/components';
import {DiscardChangesModal} from 'presentation/components/ChangeData/DiscardChangesModal';
import {SelectionFlowEnum} from 'presentation/constants';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {useLocation, useNavigate} from 'react-router-dom';
import {useChangeDataFormStateStore} from '../../store/changeDataFormStateStore';

const {changeBeneficiary, contract} = translations['pt-br'].commons;

export function PlanField() {
	const {beneficiary} = useAccountInformation();
	const [isDiscardChangesModalOpenState, setIsDiscardChangesModalOpenState] = useState(false);
	const {isFormDirty} = useChangeDataFormStateStore(state => state.formState);
	const navigate = useNavigate();
	const {pathname} = useLocation();

	const {nmPlano, nuContratoC, tipoContratacao} = beneficiary;

	const navigateToBeneficiarySelection = () => {
		navigate(SelectionFlowEnum.BENEFICIARY_SELECTION, {
			replace: true,
			state: {
				pathFrom: pathname,
			},
		});
	};

	const handleNavToBeneficiarySelection = useCallback(() => {
		if (isFormDirty) {
			setIsDiscardChangesModalOpenState(true);
			return;
		}
		navigateToBeneficiarySelection();
	}, [isFormDirty]);

	return (
		<Fragment>
			<DataCard
				title={nmPlano}
				subtitle={`${contract}: ${nuContratoC} | ${formatText(tipoContratacao)}`}
				subtitleColor="text.secondary"
				titleColor="text.secondary"
				buttonText={changeBeneficiary}
				handleAction={handleNavToBeneficiarySelection}
				footerComponent={<PlanTypeChip />}
				dataTagId={MyProfileEnum.CLICK_ALTERAR_BENEFICIARIO}
			/>

			<DiscardChangesModal
				open={isDiscardChangesModalOpenState}
				setOpen={setIsDiscardChangesModalOpenState}
				onConfirm={navigateToBeneficiarySelection}
			/>
		</Fragment>
	);
}
